export default "__VITE_ASSET__BBD2E5Oh__"